<template>
	<div class="contact-box">
		<van-nav-bar :title="title">
			<!-- <van-dropdown-menu slot="left">
			<van-dropdown-item title="导航">
			<van-row  type="flex" justify="space-around">
				<van-col span="5">
					<div class="nav1">
						 <i><img src="../assets/images/user/icon331.png"></i>
						 <span>首页</span>
					 </div>
				</van-col>
				<van-col span="5">
					<div class="nav1" @click="go('MemberCenter')">
					 <i><img src="../assets/images/user/icon332.png"></i>
					 <span>会员中心</span></div>
				</van-col> 
				<van-col span="5">
					<div class="nav1" @click="go('MeetingCenter')">
					<i><img src="../assets/images/user/icon333.png"></i>
					<span>会议中心</span></div>
				</van-col>
               <van-col span="5">
					<div class="nav1" @click="go('noticeList')">
					<i><img src="../assets/images/user/icon334.png"></i>
					<span>通知公告</span></div>
				</van-col>
			</van-row>
			<van-row   justify="space-around">
                <van-col span="5" style="margin-left:6px;">
					<div class="nav1" @click="go('proposalElection')">
					<i><img src="../assets/images/user/icon335.png"></i>
					<span>投票选举</span></div>
				</van-col>
			</van-row>
			<div class="autime">
				 <p>上次的登录时间为：{{lastLoginTime}}</p>
			 <p> 如非本人操作请及时<span  @click="go('ChangePassword')">修改密码</span></p>
			</div>
			</van-dropdown-item>
		 </van-dropdown-menu> -->
			<div slot="right" @click="logout" class="sign_out">退出登录</div>
		</van-nav-bar>
	</div>
</template>

<script>
	import {
		logout,
		getCurrentAccount,
		getLastLoginTime,

	} from "@/api/dictionary";
	import { getSessionStore } from "@/utils/sessionStorage";
	import { NavBar, Icon, Row, Col, DropdownMenu, DropdownItem, Dialog, Button } from 'vant';

	export default {
		props: ["title"],
		data() {
			return {
				lastLoginTime: "",
			};
		},
		components: {
			[NavBar.name]: NavBar,
			[Icon.name]: Icon,
			[Row.name]: Row,
			[Col.name]: Col,
			[DropdownMenu.name]: DropdownMenu,
			[DropdownItem.name]: DropdownItem,
			[Dialog.name]: Dialog,
			[Button.name]: Button,
		},

		methods: {
			go(pathName) {
				this.$router.push({ name: pathName });
			},
			// getUserInfo() {

			//    getCurrentAccount().then(res => {
			//       if (res.success) {
			//         this.getLastLoginTime(res.result.userId);
			//       }
			//     });
			// },
			// getLastLoginTime(userId) {
			//   let params = {
			//     userId
			//   };
			//   getLastLoginTime(params).then(res => {
			//     if (res.success) {
			//       this.lastLoginTime = res.result.lastLoginTime;
			//     }
			//   });
			// },
			logout() {
				Dialog.confirm({
					title: '退出系统',
					message: '您确认要退出？'
				}).then(() => {
					let token = getSessionStore("access_token");
					logout({ "access_token": token }).then(res => {
						if (res.success) {
							sessionStorage.clear()
							localStorage.clear()
							this.$router.push({ name: "login" });
						}
					});
				}).catch(() => {
					// on cancel
				});
			},
		},
		mounted() {
			// this.getUserInfo();
			// this.getLastLoginTime();
		}
	};
</script>

<style lang="less" scoped>
	/deep/.van-nav-bar {
		border-bottom: none;
		background: none;
		height: 55px;
		line-height: 55px;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	/deep/.van-nav-bar__title,
	.van-nav-bar__text {
		color: #fff !important;
		text-align: left;
		max-width: 96%;
		margin-left: 4%;
	}

	/deep/.van-dropdown-menu {
		background: none;
		height: 59px;
	}

	/deep/.van-dropdown-menu__title {
		color: #fff !important;
		padding-top: 3px;
	}

	/deep/.van-dropdown-menu__title::after {
		display: none;
	}

	.sign_out {
		color: #fff;
	}

	.nav1 {
		background: #ebf0f5;
		border-radius: 5px;
		margin-top: 20px
	}

	.nav1 i {
		display: block;
		position: relative;
		width: 43%;
		height: 30px;
		margin: 0 auto;
	}

	.nav1 img {
		position: absolute;
		top: 35%;
		left: 0;
		width: 100%;
	}

	.nav1 span {
		display: block;
		font-size: 14px;
		height: 50px;
	}

	.autime {
		text-align: left;
		margin-left: 10px;
		margin-top: 20px;
		padding-bottom: 20px;
		border-top: #dfdfdf solid 1px;
		padding-top: 20px;
	}

	.autime p {
		line-height: 28px;
		font-size: 13px;
	}

	.autime p span {
		margin-left: 10px;
		color: #f9b616;
	}

	/deep/.van-hairline--bottom::after {
		border-bottom: none;
	}
</style>